import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { automationApi, type WorkflowExecution } from '../../api/automation';

export function ExecutionMonitorPage() {
  const [executions, setExecutions] = useState<WorkflowExecution[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void automationApi.listExecutions().then((r) => setExecutions(r.executions ?? [])).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold">Execution Monitor</h1>
          <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Real-time workflow execution tracking and timeline.</p>
        </div>
        <Link to="/automation" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Automation Hub</Link>
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 space-y-2">
        {executions.length === 0 && <p className="text-sm text-slate-500">No executions yet.</p>}
        {executions.map((e) => (
          <div key={e.id} className="rounded-lg border p-4 dark:border-slate-700">
            <div className="flex items-center justify-between">
              <p className="font-medium">{e.workflow_id}</p>
              <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${
                e.status === 'running' ? 'bg-blue-100 text-blue-700 dark:bg-blue-950 dark:text-blue-300' :
                e.status === 'completed' ? 'bg-green-100 text-green-700 dark:bg-green-950 dark:text-green-300' :
                e.status === 'failed' ? 'bg-red-100 text-red-700 dark:bg-red-950 dark:text-red-300' :
                'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300'
              }`}>{e.status}</span>
            </div>
            <p className="mt-1 text-xs text-slate-500">
              v{e.workflow_version} · {e.trigger_type ?? 'manual'} · started {new Date(e.started_at).toLocaleString()}
            </p>
            {e.current_node && <p className="mt-1 text-xs text-slate-500">Current node: {e.current_node}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
